import type { TableTheme } from '../TableStyles.css';

import { tableStyles, variants } from '../TableStyles.css';
import { baseTheme } from './TableBaseTheme.css';
import { multiVariantStyles } from './TableVariants.css';

export const TableStableTheme: TableTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles: tableStyles
};
